<template>
    <div class="text-area-wrapper">
        <div
            class="leading-tight numbers-input"
            :class="value.length === 0 && 'light'"
            ref="numbers"
        >
            {{ adjustedNumbers }}
        </div>
        <textarea
            class="leading-tight main-input"
            name="main-input"
            :value="value"
            :placeholder="placeholder"
            @keyup="keyUp($event)"
            @change="keyUp($event)"
            @input="keyUp($event)"
            @scroll="sync($event)"
        ></textarea>
    </div>
</template>

<script>
    export default {

        props: {
            placeholder: {
                required: false,
                default: ''
            },
            placeholderNumbers: {
                required: false,
                default: ''
            },
            value: {
                required: true,
                default: ''
            },
            selectedTypeOfReplacementCable: {
                required: false,
                default: 'B series'
            }
        },

        data() {
            return {
                numbers: this.value.length > 0 ? Array.from({length: this.value.split('\n').length}, (_, i) => i + 1) : [1, 2],
            }
        },

        computed: {
            adjustedNumbers() {
                return this.numbers.toString().replaceAll(',', '\n')
            }
        },

        methods: {
            keyUp(event) {
                // Emit the change event to parent
                this.$emit('key-up', event);

                // Handle line number values
                if (event.target.value.length > 0) {
                    let numberOfLines = event.target.value.split('\n').length
                    this.numbers = Array.from({length: numberOfLines}, (_, i) => i + 1)
                } else {
                    this.numbers = [1, 2];
                }
            },
            sync (event) {
                this.$refs['numbers'].scrollTop = event.target.scrollTop
            }
        },

        watch: { 
            // Handle the clear of vin values from the parent component
            value: function(newVal) {
                if (newVal.length > 0) {
                    let numberOfLines = newVal.split('\n').length
                    this.numbers = Array.from({length: numberOfLines}, (_, i) => i + 1)
                } else {
                    this.numbers = [1, 2];
                }
            }
        }
    }
</script>

<style scoped>
    .text-area-wrapper {
        font-size: 18px;
        height: auto;
        position: relative;
        overflow: hidden;
    }
    .numbers-input {
        width: 30px;
        height: calc(100% - 4px);
        padding: 5px;
        padding-left: 6px;
        padding-right: 6px;
        text-align: center;
        padding-bottom: 0;
        margin-top: 2px;
        margin-left: 2px;
        position: absolute;
        background: #F6F7F9;
        border-right: 1px solid #C1C9D1;
        overflow-x: hidden;
        overflow-y: scroll;
    }
    .numbers-input::-webkit-scrollbar {
        display: none;
    }
    .numbers-input {
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */
    }
    .light {
        color: #a9a9a9;
    }
    .main-input {
        vertical-align: top;
        height: 100%;
        width: 100%;
        min-height: 120px;
        padding: 5px;
        padding-left: 38px;
        padding-bottom: 0;
        border: 2px solid #C1C9D1;
        border-radius: 4px;
    }
</style>
